import moment from 'moment';

import { HOTEL_ADDITIONAL_DETAILS_KEYS, HOTEL_PRODUCT_TYPE } from 'constants/booking';

const PASSENGER_TYPE = 'AD';
const HOTEL_TARIFF_CODE = 'HOTEL';
const PROVIDER_SYSTEM = 'JACTRAVEL';
const PASSENGER_DISABILITY_TYPE = 'NH';

export const buildBookingPassengersPayload = (numberOfPassengers, passenger) =>
  Array.from({ length: numberOfPassengers }, (_, i) => ({
    id: `passenger_${i + 1}`,
    type: PASSENGER_TYPE,
    disabilityType: PASSENGER_DISABILITY_TYPE,
    firstName: i === 0 ? passenger?.firstName ?? '' : '',
    lastName: i === 0 ? passenger?.lastName ?? '' : ''
  }));

export const getErrorKey = ({ errors, hotelInfo, hotelLoading, getHotelCalled, hasErrors }) => {
  if (errors?.jacTravelRef) {
    return 'extras.hotel.modal.jacTravelReferenceValidationError';
  } else if (errors?.hotelId) {
    return 'extras.hotel.modal.hotelIdValidationError';
  } else if (!hotelInfo && !hotelLoading && getHotelCalled) {
    return 'extras.hotel.modal.hotelNotFoundError';
  } else if (hotelInfo?.status === 'Cancelled') {
    return 'extras.hotel.modal.hotelCancelledError';
  } else if (hotelInfo?.status === 'Closed') {
    return 'extras.hotel.modal.hotelClosedError';
  } else if (moment().isAfter(moment(hotelInfo?.arrivalDate))) {
    return 'extras.hotels.modal.checkInDateInPast';
  } else if (hasErrors) {
    return 'extras.hotel.modal.errorAdd';
  }
  return null;
};

export const buildAdditionalDetails = ({ hotelItemRef, hotelInfo, hotelId, eurostarPackageRef }) => [
  {
    itemRefId: hotelItemRef,
    key: HOTEL_ADDITIONAL_DETAILS_KEYS.PROVIDER_SYSTEM,
    value: PROVIDER_SYSTEM
  },
  {
    itemRefId: hotelItemRef,
    key: HOTEL_ADDITIONAL_DETAILS_KEYS.PRODUCT_TYPE,
    value: HOTEL_PRODUCT_TYPE.HOTELS
  },
  {
    itemRefId: hotelItemRef,
    key: HOTEL_ADDITIONAL_DETAILS_KEYS.BOOKER_SURNAME,
    value: `${hotelInfo.leadGuestLastName} ${hotelInfo.leadGuestFirstName}`
  },
  ...(hotelId
    ? [
        {
          itemRefId: hotelItemRef,
          key: HOTEL_ADDITIONAL_DETAILS_KEYS.HOTEL_ID,
          value: hotelId
        }
      ]
    : []),
  ...(eurostarPackageRef
    ? [
        {
          itemRefId: hotelItemRef,
          key: HOTEL_ADDITIONAL_DETAILS_KEYS.EUROSTAR_REFERENCE,
          value: eurostarPackageRef
        }
      ]
    : []),
  {
    itemRefId: hotelItemRef,
    key: HOTEL_ADDITIONAL_DETAILS_KEYS.HOTEL_NAME,
    value: hotelInfo.hotelName
  },
  {
    itemRefId: hotelItemRef,
    key: HOTEL_ADDITIONAL_DETAILS_KEYS.NUMBER_OF_NIGHTS,
    value: String(hotelInfo.duration)
  },
  {
    itemRefId: hotelItemRef,
    key: HOTEL_ADDITIONAL_DETAILS_KEYS.GUEST_COUNT,
    value: String(hotelInfo.numberOfGuests)
  },
  {
    itemRefId: hotelItemRef,
    key: HOTEL_ADDITIONAL_DETAILS_KEYS.ROOM_COUNT,
    value: String(hotelInfo.numberOfRooms)
  },
  {
    itemRefId: hotelItemRef,
    key: HOTEL_ADDITIONAL_DETAILS_KEYS.HOTEL_ADDRESS,
    value: hotelInfo.address
  },
  {
    itemRefId: hotelItemRef,
    key: HOTEL_ADDITIONAL_DETAILS_KEYS.HOTEL_COUNTRY,
    value: hotelInfo.country
  }
];

export const buildCreateProvisionalBookingVariables = ({ hotelInfo, marginTariff }) => ({
  language: 'EN', // Hardcoded to English for now https://eurostar.atlassian.net/browse/VOY-1366
  currency: hotelInfo.currency,
  segments: [
    {
      startValidityDate: hotelInfo.arrivalDate,
      items: [
        { passengerId: 'passenger_1', tariffCode: HOTEL_TARIFF_CODE },
        { passengerId: 'passenger_1', tariffCode: marginTariff.MARGIN_HOTEL }
      ]
    }
  ],
  passengers: buildBookingPassengersPayload(hotelInfo.numberOfGuests, {
    lastName: hotelInfo.leadGuestLastName,
    firstName: hotelInfo.leadGuestFirstName
  })
});
